import React, { useEffect } from 'react';
import Highcharts from 'highcharts';
import { text } from 'stream/consumers';

interface MyChartProps {
  chartId: string;  // Nuevo prop para identificar cada instancia del gráfico
  plot:any,
  data:any
}


const MyChart: React.FC<MyChartProps> = ({ chartId,plot ,data}) => {
  useEffect(() => {
    // Create the Highcharts chart here
    const options: Highcharts.Options = {
      title: {
        text: 'CPU Usage',
        align: 'left',
      },
      // ... other chart options ...
      subtitle: {
        text: 'CPU currently in use.',
        align: 'left'
    },

    yAxis: {
        title: {
            text: 'Percentage (%)'
        }
    },

    xAxis: {
      type: 'datetime',
      categories:(plot),
      labels: {
          overflow: 'justify'
      }
  },

    legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle'
    },

    plotOptions: {
        series: {
            label: {
                connectorAllowed: false
            },
        }
    },

    series: [{
        type:'line',
        name: 'Usage in percentage',
        data: data
     }],

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      },
      credits: {
        enabled: false
    }
    };

    Highcharts.chart(`container-${chartId}`, options)
  }, [chartId]); // Empty dependency array to ensure the effect runs only once when the component mounts

  return (
    <div id={`container-${chartId}`}>
      {/* El contenedor div donde se renderizará el gráfico */}
    </div>
  );
};

export default MyChart;